/**
 * Supabase Auth client — used for the auth gate.
 * Reuses the same Inventory project URL + anon key as `marketing` since auth
 * lives at the project level, not the schema level.
 */
import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_MARKETING_URL;
const key = import.meta.env.VITE_SUPABASE_MARKETING_ANON_KEY;

export const authClient = createClient(url ?? 'http://localhost', key ?? 'anon', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
  },
});
